module.exports = __webpack_public_path__ + "img/App.f129bd2d.png";